import React from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate, useLocation } from "react-router-dom";
import Technologies3DPrinting from "./pages/Technologies3DPrinting";
import { HowItWorks } from "./pages/HowItWorks";
import Research from "./pages/Research";
import { StartNow } from "./pages/startNow";
import Dashboard from "./pages/dashboard";
import Login from "./pages/login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import PatientDashboard from "./pages/patientDashboard";
import BuyNowSucess from "./pages/BuyNowSucess";
import IntrestForm from "./pages/IntrestForm";
// Hide: Price and Cart
// import ShoppingCartPage from "./pages/Shopping/shopping-cart";
// import ProductInfoPage from "./pages/Shopping/featured";
import ShoppingPage from "./pages/Shopping/shopping";
import ProfilePage from "./pages/Profile/ProfilePage";
import ProfileSettingsPage from "./pages/Profile/ProfileSettingsPage";
import ConfirmSignup from "./pages/Confirm";

import ThankYou from "./pages/thankyou";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";

import Landing from "./pages/landing";
import MarketingLayout from "./layouts/MarketingLayout";
import AuthSplitLayout from "./layouts/AuthSplitLayout";
import DashboardLayout from "./layouts/DashboardLayout";
import AccessRequests from "./pages/Admin/AccessRequests";
import AdminLayout from "./pages/Admin/AdminLayout";
import AdminOverview from "./pages/Admin/AdminOverview";
import AdminPatient from "./pages/Admin/AdminPatient";

const UnknownRouteRedirect: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/", { replace: true });
  }, [navigate]);

  return null;
};

// Reset scroll on route change so every link lands at the top of the page.
// In-page anchors (e.g. #outcomes) keep their default jump behavior.
const ScrollToTop: React.FC = () => {
  // `key` changes on every navigation, including a link to the current page.
  const { key, hash } = useLocation();

  React.useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [key, hash]);

  return null;
};

const AppRouter: React.FC = () => (
  <Router>
    <ScrollToTop />
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/technologies/3Dprinting" element={<Technologies3DPrinting />} />
        <Route path="/thankyou" element={<ThankYou />} />
        {/* Hide: Price and Cart */}
        <Route path="/buy-now" element={<Navigate to="/shopping" replace />} />

        <Route path="/buy-now/success" element={<BuyNowSucess />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/research" element={<Research />} />
        <Route path="/start" element={<StartNow />} />
        <Route path="/interest-form" element={<IntrestForm />} />
        {/* Hide: Price and Cart */}
        <Route path="/shopping/cart" element={<Navigate to="/shopping" replace />} />
        <Route path="/shopping/info" element={<Navigate to="/shopping" replace />} />
        
        <Route path="/shopping" element={<ShoppingPage />} />
      </Route>

      <Route element={<AuthSplitLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/confirm" element={<ConfirmSignup />} />
      </Route>

      <Route element={<DashboardLayout />}>
        <Route path="/dashboard/preview" element={<Dashboard previewMode />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/patient-dashboard/preview"
          element={<PatientDashboard previewMode />}
        />
        <Route path="/patient-dashboard" element={<PatientDashboard />} />
        <Route path="/patient-results" element={<Navigate to="/patient-dashboard" replace />} />
        <Route path="/patient-settings" element={<Navigate to="/profile/settings" replace />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/settings" element={<ProfileSettingsPage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="requests" element={<AccessRequests />} />
          <Route path="patients/:email" element={<AdminPatient />} />
        </Route>
      </Route>
      <Route path="*" element={<UnknownRouteRedirect />} />
    </Routes>
  </Router>
);

export default AppRouter;
